import { ReembolsoService } from './../../services/reembolso.service';
import { NotificationService } from './../../notification/swal/notification.service';
import { Component, OnInit } from '@angular/core';
import { ReembolsoModel } from './reembolso.model';
import { Form } from '../../services/form';
import { Params, ActivatedRoute, Router } from '@angular/router';
import Auth from '../../helpers/auth';
import { MaskHelper } from '../../helpers/mask';
import { DependentService } from '../../services/dependent.service';
import { DependentMeepServerModel } from '../../models/dependent.model';
import Bank from '../../helpers/bank';
import { InputSelectModel } from '../input-select/inputSelect.model';
import { InputModel } from '../input/input.model';
import { RequiredModel } from '../input/rules/implementations/required.model';

@Component({
  selector: 'app-reembolso',
  templateUrl: './reembolso.component.html',
  styleUrls: ['./reembolso.component.less']
})
export class ReembolsoComponent extends Form implements OnInit {

  reembolsoModel: ReembolsoModel;
  dependent: DependentMeepServerModel = new DependentMeepServerModel();
  tipoReembolso: number;
  routeParams: Params;
  deveExibirCampoDigito: boolean = false;

  constructor(private notificationService: NotificationService, private reembolsoService: ReembolsoService,
    private dependentService: DependentService, private route: ActivatedRoute, private router: Router) {
    super();
    this.route.params.subscribe((params: Params) => {
      this.routeParams = params;
      this.reembolsoModel = new ReembolsoModel(this.routeParams['tipoReembolso']);
    });
  }

  ngOnInit() {
    const user = Auth.getUser();
    this.reembolsoModel.ddd = Auth.getUser().ddd;
    this.reembolsoModel.celular = Auth.getUser().telefone;
    this.reembolsoModel.ContaBancaria.CPF = user.cpf;
    this.reembolsoModel.ContaBancaria.Tipo = "1";
    this.reembolsoModel.ContaBancaria.CodigoBancoInputModel = Bank.getBankAccounts().map<InputSelectModel>(b => ({title: b.text, value: b.value}));

    this.dependentService.getFromMeepServer(this.getIdDoCartao(), this.routeParams['tipoCartao'])
      .then((_dependent: DependentMeepServerModel) => {
        this.dependent = _dependent;

        this.reembolsoModel.Valor = this.dependent.Saldo;
        this.reembolsoModel.ValorToShow = this.dependent.Saldo.toFixed(2).toString().replace('.', ',');
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private getIdDoCartao(): string {
    if (this.routeParams['tipoCartao'] === 'rotativo') {
      return this.routeParams['historicoAssociacaoId'];
    } else {
      return this.routeParams['id'];
    }
  }

  onInput(event: any, fieldName: string): void {
    if (!/^\d+$/.test(event.target.value) && fieldName === 'Conta' || fieldName === 'Agencia') {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
    }
    // Atualize o modelo com o valor tratado
    switch (fieldName) {
      case 'Conta':
        this.reembolsoModel.ContaBancaria.Conta = event.target.value;
        break;
      case 'Agencia':
        this.reembolsoModel.ContaBancaria.Agencia = event.target.value;
        break;
    }
  }

  deveSalvar() {
    this.reembolsoModel.ContaBancaria.DeveSalvar = !this.reembolsoModel.ContaBancaria.DeveSalvar;
  }

  exibeDigito(event: any) {
    // Regra para exibir campo de dígito para o banco do brasil
    if (event === "001") {
      this.reembolsoModel.ContaBancaria.AgenciaDigitoInputModel = new InputModel(false, false, 'text', null, [new RequiredModel()]);
      this.deveExibirCampoDigito = true;
    } else {
      this.deveExibirCampoDigito = false;
      this.reembolsoModel.ContaBancaria.AgenciaDigitoInputModel = new InputModel(false, false, 'text', null, []);
    }
  }

  solicitar() {
    this.reembolsoModel.celular = MaskHelper.removeTelefone(this.reembolsoModel.celular);
    this.reembolsoModel.Valor = MaskHelper._removeCurrency(this.reembolsoModel.ValorToShow);
    const valorNotZero = MaskHelper._removeCurrency(this.reembolsoModel.Valor) !== 0;

    const isFormValid = this.getFormStatus() && this.reembolsoModel.Valor && valorNotZero;

    if (isFormValid) {
      this.reembolsoService.solicitarReembolso(this.reembolsoModel, this.routeParams['historicoAssociacaoId'])
        .then(() => {
          this.notificationService.showSuccessNotification('Solicitação feita com sucesso!')
            .then(() => {
              this.router.navigate(['/general/cartoesDependentes']);
            });
        })
        .catch((err) => this.notificationService.showErrorNotification(err.message ? err.message : err.errors[0].messages[0]));
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/reembolso/reembolso.component.ts